import config from 'constants/config'

export const getIsMultiTravellerEnabled = (businessAccount: App.BusinessTraveller.CurrentBusinessAccount) => {
  // Allow LE test account and (soon) LE business travel account to use multi-traveller in prod
  const businessAccountIds = ['cd0bed12-e959-4c76-a5a9-a10d7f6c62d0'] //, 'e3ba5516-d08a-44d4-9411-2d652674d2f2']
  return config.BUSINESS_TRAVELLER_MULTI_TRAVELLER_ENABLED || businessAccountIds.includes(businessAccount?.business?.id ?? '')
}
